import BaseContract from "../../BaseContract";

export default class BaseMarketplaceContract extends BaseContract {}
